export default "__VITE_ASSET__DEyiM2Id__"